import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { BlockResources, ResourceApiService } from '@zorro/apiclient';
import { tap } from 'rxjs/operators';
import { TextResourceService } from './text-resource.service';

/**
 * Manages the page title for the new PRO layout.
 */
@Injectable()
export class TextResourceResolve  {

  constructor(
    private readonly resourceService: ResourceApiService,
    private readonly textResourceService: TextResourceService) { }

  resolve(
    route: ActivatedRouteSnapshot): Promise<BlockResources[]> {
    const appName = 'ZorroAdvieswijzer';
    const routeName = route.data.routeName;
    const lang = route.data.lang;

    return this.resourceService.getResourcesByRoute(appName, routeName, lang)
      .pipe(tap((resources: BlockResources[]) => this.textResourceService.setResources(resources)
      )).toPromise();
  }
}
